// extracted by mini-css-extract-plugin
export default {"content":"NotFoundContent_content__WPP5m"};